<template>
  <div class="file-selector-wrapper">
    <slot :open-file-selector="openFileSelector" :files="selectedFiles" />

    <input
      ref="fileInput"
      class="input input--invisible"
      type="file"
      v-bind="$attrs"
      :accept="accept"
      @change="fileChangeHandler"
    />
  </div>
</template>

<script>
import { hasValidExtension } from '@/utils/file-utils/file-validators';

export default {
  name: 'FileSelectorWrapper',

  props: {
    accept: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectedFiles: null,
    };
  },

  methods: {
    openFileSelector() {
      this.$refs.fileInput?.click();
    },

    fileChangeHandler(event) {
      const { files = [] } = event.target;
      const filesArray = Array.from(files);
      const validFiles = [];
      const invalidFiles = [];

      filesArray.forEach(file => {
        if (hasValidExtension(file, this.accept)) validFiles.push(file);
        else invalidFiles.push(file);
      });

      this.selectedFiles = validFiles;
      this.$emit('select-files', validFiles);
      this.$emit('select-invalid-files', invalidFiles);
    },

    reset() {
      if (this.$refs.fileInput) {
        this.selectedFiles = null;
        this.$refs.fileInput.value = null;
      }
    },
  },
};
</script>
